var map = {
	"./demoinsurance/piattaforma-prodotti/censimento/ProtezioneInvestimento.vue": [
		"8017",
		"configuration~configuration0~configuration1~configuration2",
		"configuration0"
	],
	"./global/piattaforma-prodotti/censimento/ProtezioneInvestimento.vue": [
		"44bd",
		"configuration~configuration0~configuration1~configuration2",
		"configuration1~configuration2",
		"configuration1"
	],
	"./shdev/piattaforma-prodotti/censimento/ProtezioneInvestimento.vue": [
		"525b",
		"configuration~configuration0~configuration1~configuration2",
		"configuration1~configuration2",
		"configuration2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "e4a2";
module.exports = webpackAsyncContext;